import { MetadataHandler } from '@/app/shared/components/MetadataHandler';
import Stips from './Stips';

export const DocumentsRedirect = () => {

  return (
    <MetadataHandler>
      <Stips />
    </MetadataHandler>
  );
};